import styled from 'styled-components';



export const ScrollVerticalContainer = styled.div`
  
`;
